import { Effect, Reducer } from '@umijs/max';
import {
  getPharmaciesTopBySum,
  getPharmaciesTopByCount,
  getPharmaciesProductsTopBySum,
  getPharmaciesProductsTopByCount,
} from '@/services/consumptions.service';

import { Statistics } from './data';

export interface ModelType {
  namespace: string;
  state: Statistics;
  effects: {
    fetchPharmaciesTops: Effect;
    fetchPharmaciesProductsTops: Effect;
  };
  reducers: {
    save: Reducer<Statistics>;
    clear: Reducer<Statistics>;
  };
}

const initState = {
  pharmacySumTop: null as any,
  pharmacyCountTop: null as any,
  pharmacyProductsSumTop: null as any,
  pharmacyProductsCountTop: null as any,
};

const Model: ModelType = {
  namespace: 'consumptionsStatistics',

  state: initState,

  effects: {
    *fetchPharmaciesTops({ payload }, { all, call, put }) {
      yield put({
        type: 'save',
        payload: { pharmacySumTop: null, pharmacyCountTop: null },
      });
      const [pharmacySumTop, pharmacyCountTop] = yield all([
        call(getPharmaciesTopBySum, payload),
        call(getPharmaciesTopByCount, payload),
      ]);
      
      yield put({
        type: 'save',
        payload: { 
          pharmacySumTop: pharmacySumTop, 
          pharmacyCountTop: pharmacyCountTop
        },
      });
    },

    *fetchPharmaciesProductsTops({ payload }, { all, call, put }) {
      yield put({
        type: 'save',
        payload: { pharmacyProductsSumTop: null, pharmacyProductsCountTop: null },
      });
      const [pharmacyProductsSumTop, pharmacyProductsCountTop] = yield all([
        call(getPharmaciesProductsTopBySum, payload),
        call(getPharmaciesProductsTopByCount, payload),
      ]);

      yield put({
        type: 'save',
        payload: { 
          pharmacyProductsSumTop: pharmacyProductsSumTop,
          pharmacyProductsCountTop: pharmacyProductsCountTop
        },
      });
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    clear() {
      return initState;
    },
  },
};

export default Model;
